(function () {
'use strict';
var SM = window.ShoppingMood || {};
SM.routes = SM.routes || {};
function formatMoney(cents) {
var value = (cents / 100).toFixed(2);
var format = (SM.money && SM.money.format) || '₹{{amount}}';
return format.replace(/\{\{\s*amount\s*\}\}/, value);
}
function toast(message) {
var el = document.createElement('div');
el.className = 'sm-toast';
el.textContent = message;
document.body.appendChild(el);
requestAnimationFrame(function () { el.classList.add('is-visible'); });
setTimeout(function () {
el.classList.remove('is-visible');
setTimeout(function () { el.remove(); }, 320);
}, 2400);
}
function getCart() {
return fetch(SM.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
.then(function (r) { return r.json(); });
}
var drawer = document.getElementById('sm-cart-drawer');
var overlay = document.getElementById('sm-cart-overlay');
function openCart() {
if (overlay) overlay.classList.add('is-open');
if (drawer) drawer.classList.add('is-open');
document.body.style.overflow = 'hidden';
}
function closeCart() {
if (overlay) overlay.classList.remove('is-open');
if (drawer) drawer.classList.remove('is-open');
document.body.style.overflow = '';
}
function updateCartCount(count) {
document.querySelectorAll('[data-cart-count]').forEach(function (node) {
node.textContent = count;
node.hidden = count === 0 ? false : false;
});
}
function renderCart(cart) {
var itemsWrap = document.getElementById('sm-cart-items');
var subtotalEl = document.getElementById('sm-cart-subtotal');
if (!itemsWrap) return;
updateCartCount(cart.item_count);
if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
if (cart.item_count === 0) {
itemsWrap.innerHTML =
'<div class="sm-cart__empty">' +
'<div class="sm-cart__empty-icon">🛒</div>' +
'<p style="font-family:var(--sm-heading-font);font-weight:700;font-size:15px;margin-bottom:6px;">Your bag is empty!</p>' +
'<a href="/collections/all" class="sm-btn sm-btn--primary" style="margin-top:12px;">Shop Now</a>' +
'</div>';
return;
}
var html = '';
cart.items.forEach(function (item) {
var img = item.image
? item.image.replace(/(\.[^.]*)$/, '_160x200$1')
: '';
html +=
'<div class="sm-cart-item" data-line-key="' + item.key + '">' +
(img ? '<img class="sm-cart-item__img" src="' + img + '" alt="' + (item.product_title || '') + '" loading="lazy">' : '') +
'<div class="sm-cart-item__info">' +
'<div class="sm-cart-item__title">' + item.product_title + '</div>' +
(item.variant_title && item.variant_title !== 'Default Title'
? '<div class="sm-cart-item__variant">' + item.variant_title + '</div>' : '') +
'<div class="sm-cart-item__price">' + formatMoney(item.final_price) + '</div>' +
'<div class="sm-qty" style="margin-top:8px;">' +
'<button class="sm-qty__btn" data-line-change="-1" aria-label="Decrease">&minus;</button>' +
'<input class="sm-qty__input" type="number" min="0" value="' + item.quantity + '" data-line-input aria-label="Quantity">' +
'<button class="sm-qty__btn" data-line-change="1" aria-label="Increase">+</button>' +
'</div>' +
'<a class="sm-cart-item__remove" data-line-remove>Remove</a>' +
'</div>' +
'</div>';
});
itemsWrap.innerHTML = html;
}
function changeLine(key, quantity) {
return fetch(SM.routes.cartChange + '.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ id: key, quantity: quantity })
}).then(function (r) { return r.json(); }).then(function (cart) {
renderCart(cart);
return cart;
});
}
var _flyActive = false;
function flyToCart(button) {
if (_flyActive) return;
_flyActive = true;
setTimeout(function() { _flyActive = false; }, 1200);
var cartIcon = document.querySelector('[data-cart-toggle] i');
if (!cartIcon || !button) return;
var btnRect = button.getBoundingClientRect();
var cartRect = cartIcon.getBoundingClientRect();
var startX = btnRect.left + btnRect.width / 2 - 12;
var startY = btnRect.top + btnRect.height / 2 - 12;
var endX = cartRect.left + cartRect.width / 2 - 12;
var endY = cartRect.top + cartRect.height / 2 - 12;
var cpX = startX + (endX - startX) * 0.8;
var cpY = Math.min(startY, endY) - 120;
var fly = document.createElement('div');
fly.innerHTML = '<i class="fas fa-shopping-bag"></i>';
fly.style.cssText = [
'position:fixed',
'z-index:99999',
'pointer-events:none',
'left:' + startX + 'px',
'top:' + startY + 'px',
'width:26px',
'height:26px',
'display:flex',
'align-items:center',
'justify-content:center',
'background:#FF4D8D',
'color:#fff',
'border-radius:50%',
'font-size:13px',
'opacity:1',
'box-shadow:0 4px 14px rgba(255,77,141,0.6)',
].join(';');
document.body.appendChild(fly);
var duration = 1100; 
var start = null;
function step(timestamp) {
if (!start) start = timestamp;
var elapsed = timestamp - start;
var progress = Math.min(elapsed / duration, 1);
var t = progress < 0.5
? 2 * progress * progress
: 1 - Math.pow(-2 * progress + 2, 2) / 2;
var x = (1-t)*(1-t)*startX + 2*(1-t)*t*cpX + t*t*endX;
var y = (1-t)*(1-t)*startY + 2*(1-t)*t*cpY + t*t*endY;
var scale = 1 - (t * 0.7);
var opacity = progress > 0.75 ? 1 - ((progress - 0.75) / 0.25) : 1;
fly.style.left = x + 'px';
fly.style.top = y + 'px';
fly.style.transform = 'scale(' + scale + ')';
fly.style.opacity = opacity;
if (progress < 1) {
requestAnimationFrame(step);
} else {
fly.remove();
cartIcon.style.transition = 'transform 0.15s';
cartIcon.style.transform = 'scale(1.6)';
setTimeout(function() {
cartIcon.style.transition = 'transform 0.15s';
cartIcon.style.transform = 'scale(1)';
}, 150);
}
}
requestAnimationFrame(step);
}
function addToCart(form, button) {
var formData = new FormData(form);
if (button) {
flyToCart(button);
button.disabled = true;
button.dataset.originalHtml = button.innerHTML;
button.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
}
return fetch(SM.routes.cartAdd + '.js', {
method: 'POST',
headers: { 'Accept': 'application/json' },
body: formData
})
.then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
.then(function (res) {
if (!res.ok) {
toast(res.data.description || 'Could not add to bag');
return null;
}
return getCart().then(function (cart) {
renderCart(cart);
if (button) {
button.innerHTML = '<i class="fas fa-check"></i> Added!';
setTimeout(function () { button.innerHTML = button.dataset.originalHtml; button.disabled = false; }, 1600);
}
toast((SM.strings && SM.strings.addedToCart) || 'Added to bag!');
openCart();
return cart;
});
})
.catch(function () {
if (button) { button.innerHTML = button.dataset.originalHtml; button.disabled = false; }
toast('Something went wrong. Please try again.');
});
}
var WISHLIST_KEY = 'sm_wishlist';
function getWishlist() {
try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
catch (e) { return []; }
}
function setWishlist(list) {
try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
updateWishlistCount(list.length);
}
function updateWishlistCount(count) {
document.querySelectorAll('[data-wishlist-count]').forEach(function (n) { n.textContent = count; });
}
function toggleWishlist(handle, button) {
var list = getWishlist();
var idx = list.indexOf(handle);
if (idx === -1) {
list.push(handle);
if (button) { button.classList.add('is-active'); button.innerHTML = '<i class="fas fa-heart"></i>'; }
toast((SM.strings && SM.strings.addToWishlist) || 'Added to wishlist!');
} else {
list.splice(idx, 1);
if (button) { button.classList.remove('is-active'); button.innerHTML = '<i class="far fa-heart"></i>'; }
toast((SM.strings && SM.strings.removeFromWishlist) || 'Removed from wishlist');
}
setWishlist(list);
}
function initWishlistStates() {
var list = getWishlist();
updateWishlistCount(list.length);
document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
if (list.indexOf(btn.dataset.wishlistToggle) !== -1) {
btn.classList.add('is-active');
btn.innerHTML = '<i class="fas fa-heart"></i>';
}
});
}
function initPredictiveSearch() {
var input = document.querySelector('[data-predictive-input]');
var results = document.querySelector('[data-predictive-results]');
if (!input || !results || !SM.routes.predictiveSearch) return;
var timer = null;
input.addEventListener('input', function () {
var q = input.value.trim();
clearTimeout(timer);
if (q.length < 2) { results.innerHTML = ''; results.hidden = true; return; }
timer = setTimeout(function () {
var url = SM.routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
'&resources[type]=product&resources[limit]=6&section_id=predictive-search';
fetch(url).then(function (r) { return r.text(); }).then(function (html) {
results.innerHTML = html;
results.hidden = false;
}).catch(function () {});
}, 250);
});
document.addEventListener('click', function (e) {
if (!results.contains(e.target) && e.target !== input) { results.hidden = true; }
});
}
document.addEventListener('click', function (e) {
var trigger = e.target.closest('[data-cart-toggle]');
if (trigger) { e.preventDefault(); getCart().then(renderCart).then(openCart); return; }
if (e.target.closest('#sm-cart-close') || e.target.closest('[data-cart-close]')) { closeCart(); return; }
if (e.target.id === 'sm-cart-overlay') { closeCart(); return; }
var wish = e.target.closest('[data-wishlist-toggle]');
if (wish) { e.preventDefault(); toggleWishlist(wish.dataset.wishlistToggle, wish); return; }
var changeBtn = e.target.closest('[data-line-change]');
if (changeBtn) {
var itemEl = changeBtn.closest('[data-line-key]');
var input = itemEl.querySelector('[data-line-input]');
var newQty = parseInt(input.value, 10) + parseInt(changeBtn.dataset.lineChange, 10);
if (newQty < 0) newQty = 0;
input.value = newQty;
var lineKey = itemEl.dataset.lineKey;
if (!window._smQtyTimers) window._smQtyTimers = {};
clearTimeout(window._smQtyTimers[lineKey]);
window._smQtyTimers[lineKey] = setTimeout(function() {
changeLine(lineKey, newQty);
delete window._smQtyTimers[lineKey];
}, 400);
return;
}
var removeBtn = e.target.closest('[data-line-remove]');
if (removeBtn) {
var row = removeBtn.closest('[data-line-key]');
changeLine(row.dataset.lineKey, 0);
return;
}
});
document.addEventListener('change', function (e) {
var input = e.target.closest('[data-line-input]');
if (input) {
var row = input.closest('[data-line-key]');
var qty = parseInt(input.value, 10);
if (isNaN(qty) || qty < 0) qty = 0;
changeLine(row.dataset.lineKey, qty);
}
});
// Add to Bag — form submit
document.addEventListener('submit', function (e) {
var form = e.target.closest('[data-product-form]');
if (!form) return;
e.preventDefault();
var btn = form.querySelector('[type="submit"]');
addToCart(form, btn);
});


function goToCheckout() {
var f = document.createElement('form');
f.method = 'POST';
f.action = '/checkout';
var inp = document.createElement('input');
inp.type = 'hidden';
inp.name = 'checkout';
inp.value = '1';
f.appendChild(inp);
document.body.appendChild(f);
f.submit();
}

// ── Dedicated Buy Now size popup (always goes to checkout) ──
(function() {
var bnPopup = document.createElement('div');
bnPopup.className = 'sm-size-popup';
bnPopup.innerHTML =
'<div class="sm-size-popup__overlay" data-bn-close></div>' +
'<div class="sm-size-popup__card">' +
'<button type="button" class="sm-size-popup__close" data-bn-close>&times;</button>' +
'<div class="sm-size-popup__product">' +
'<img class="sm-size-popup__img" data-bn-img src="" alt="">' +
'<div>' +
'<div class="sm-size-popup__title" data-bn-title></div>' +
'<div class="sm-size-popup__price" data-bn-price></div>' +
'</div>' +
'</div>' +
'<div class="sm-size-popup__label">Select Size</div>' +
'<div class="sm-size-popup__options" data-bn-options></div>' +
'<button type="button" class="sm-btn sm-btn--dark sm-btn--full sm-size-popup__proceed" data-bn-proceed disabled>' +
'<i class="fas fa-bolt"></i> Buy Now' +
'</button>' +
'</div>';
bnPopup.style.display = 'none';
document.body.appendChild(bnPopup);
var bnSelectedVariantId = null;
function openBnPopup(btn) {
var title = btn.dataset.productTitle || '';
var image = btn.dataset.productImage || '';
var price = btn.dataset.productPrice || '';
var variants = [];
try { variants = JSON.parse(btn.dataset.variants || '[]'); } catch(e) {}
bnSelectedVariantId = null;
bnPopup.querySelector('[data-bn-title]').textContent = title;
bnPopup.querySelector('[data-bn-price]').textContent = price;
var img = bnPopup.querySelector('[data-bn-img]');
if (image) { img.src = image; img.style.display = 'block'; } else { img.style.display = 'none'; }
var optionsEl = bnPopup.querySelector('[data-bn-options]');
optionsEl.innerHTML = '';
variants.forEach(function(v) {
var b = document.createElement('button');
b.type = 'button';
b.className = 'sm-size-popup__size' + (v.available ? '' : ' is-soldout');
b.textContent = v.title;
b.disabled = !v.available;
b.dataset.variantId = v.id;
if (v.available) {
b.addEventListener('click', function(e) {
e.stopPropagation();
optionsEl.querySelectorAll('.sm-size-popup__size').forEach(function(s) { s.classList.remove('is-selected'); });
this.classList.add('is-selected');
bnSelectedVariantId = v.id;
// Auto-proceed: add to cart and trigger Razorpay immediately on size select
var proceedBtn = bnPopup.querySelector('[data-bn-proceed]');
proceedBtn.disabled = true;
proceedBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Please wait...';
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
credentials: 'same-origin',
body: JSON.stringify({ items: [{ id: parseInt(v.id), quantity: 1 }] })
})
.then(function() {
bnPopup.style.display = 'none';
document.body.style.overflow = '';
var rzInput = document.getElementById('sm-rz-variant-input');
var rzBtn = document.getElementById('sm-rz-buynow-trigger');
if (rzBtn && rzInput) {
rzInput.value = v.id;
rzBtn.click();
} else {
goToCheckout();
}
})
.catch(function() { goToCheckout(); });
});
}
optionsEl.appendChild(b);
});
bnPopup.querySelector('[data-bn-proceed]').disabled = true;
bnPopup.style.display = 'flex';
document.body.style.overflow = 'hidden';
}
function closeBnPopup() {
bnPopup.style.display = 'none';
document.body.style.overflow = '';
}
bnPopup.querySelectorAll('[data-bn-close]').forEach(function(el) {
el.addEventListener('click', closeBnPopup);
});
bnPopup.querySelector('[data-bn-proceed]').addEventListener('click', function() {
if (!bnSelectedVariantId) return;
var btn = this;
btn.disabled = true;
btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Please wait...';
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
credentials: 'same-origin',
body: JSON.stringify({ items: [{ id: parseInt(bnSelectedVariantId), quantity: 1 }] })
})
.then(function() {
// Close popup first
bnPopup.style.display = 'none';
document.body.style.overflow = '';
// Set variant on hidden form and click - Razorpay intercepts .sm-pdp__buynow clicks
var rzInput = document.getElementById('sm-rz-variant-input');
var rzBtn = document.getElementById('sm-rz-buynow-trigger');
if (rzBtn && rzInput) {
rzInput.value = bnSelectedVariantId;
rzBtn.click();
} else {
goToCheckout();
}
})
.catch(function() { window.location.href = '/checkout'; });
});
document.addEventListener('click', function(e) {
var trigger = e.target.closest('[data-open-buynow-popup]');
if (trigger) { e.preventDefault(); openBnPopup(trigger); }
});
})();

// Homepage card Buy Now (single variant) — direct to checkout
document.addEventListener('click', function (e) {
var cardBtn = e.target.closest('[data-buy-now-card]');
if (cardBtn) {
e.preventDefault();
e.stopPropagation();
var variantId = cardBtn.dataset.variantId;
if (!variantId) { window.location.href = '/checkout'; return; }
cardBtn.disabled = true;
cardBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Please wait...';
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
credentials: 'same-origin',
body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
})
.then(function() { goToCheckout(); })
.catch(function() { goToCheckout(); });
return;
}
});

// Buy Now — fully independent, never uses form submit
document.addEventListener('click', function (e) {
var btn = e.target.closest('[data-buy-now]');
if (!btn) return;
e.preventDefault();
e.stopPropagation();
var form = btn.closest('[data-product-form]') || document.querySelector('[data-product-form]');
if (!form) { window.location.href = '/checkout'; return; }
btn.disabled = true;
btn.innerHTML = '<i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Please wait...';
var formData = new FormData(form);
var variantId = formData.get('id');
var quantity = parseInt(formData.get('quantity') || 1);
if (!variantId) { window.location.href = '/checkout'; return; }
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
credentials: 'same-origin',
body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: quantity }] })
})
.then(function() { goToCheckout(); })
.catch(function() { goToCheckout(); });
});
document.addEventListener('click', function (e) {
var step = e.target.closest('[data-qty-step]');
if (!step) return;
var wrap = step.closest('[data-qty]');
var input = wrap && wrap.querySelector('input');
if (!input) return;
var val = parseInt(input.value, 10) || 1;
val += parseInt(step.dataset.qtyStep, 10);
if (val < 1) val = 1;
input.value = val;
input.dispatchEvent(new Event('change', { bubbles: true }));
});
function init() {
initWishlistStates();
initPredictiveSearch();
getCart().then(function (cart) { updateCartCount(cart.item_count); }).catch(function () {});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
window.ShoppingMood.openCart = openCart;
window.ShoppingMood.closeCart = closeCart;
window.ShoppingMood.toast = toast;
window.ShoppingMood.getCart = getCart;
window.ShoppingMood.renderCart = renderCart;
window.ShoppingMood.updateCartCount = updateCartCount;
})();
(function() {
var drawer = document.querySelector('[data-menu-drawer]');
var overlay = document.querySelector('[data-menu-overlay]');
if (!drawer || !overlay) return;
var openBtn = document.querySelector('[data-menu-open]');
var closeBtn = document.querySelector('[data-menu-close]');
function openMenu() {
overlay.hidden = false;
requestAnimationFrame(function() {
overlay.classList.add('is-open');
drawer.classList.add('is-open');
});
drawer.setAttribute('aria-hidden', 'false');
drawer.removeAttribute('inert');
document.body.style.overflow = 'hidden';
}
function closeMenu() {
overlay.classList.remove('is-open');
drawer.classList.remove('is-open');
drawer.setAttribute('aria-hidden', 'true');
drawer.setAttribute('inert', '');
document.body.style.overflow = '';
setTimeout(function() { overlay.hidden = true; }, 300);
}
if (openBtn) openBtn.addEventListener('click', openMenu);
if (closeBtn) closeBtn.addEventListener('click', closeMenu);
overlay.addEventListener('click', closeMenu);
drawer.querySelectorAll('[data-submenu-toggle]').forEach(function(btn) {
btn.addEventListener('click', function() {
var sub = btn.nextElementSibling;
var open = btn.getAttribute('aria-expanded') === 'true';
btn.setAttribute('aria-expanded', open ? 'false' : 'true');
if (sub) sub.hidden = open;
});
});
})();
(function() {
var header = document.querySelector('.sm-header');
if (header) {
var lastY = 0;
window.addEventListener('scroll', function() {
var y = window.scrollY || window.pageYOffset;
if (y > 20) header.classList.add('is-shrunk');
else header.classList.remove('is-shrunk');
lastY = y;
}, { passive: true });
}
var path = window.location.pathname;
var tabs = document.querySelectorAll('.sm-mobile-nav__item');
tabs.forEach(function(tab) {
var href = tab.getAttribute('href');
if (!href) return;
if (href === '/' && (path === '/' || path === '')) tab.setAttribute('aria-current', 'page');
else if (href !== '/' && path.indexOf(href) === 0) tab.setAttribute('aria-current', 'page');
});
(function() {
var popup = document.createElement('div');
popup.className = 'sm-size-popup';
popup.innerHTML =
'<div class="sm-size-popup__overlay" data-size-close></div>' +
'<div class="sm-size-popup__card">' +
'<button type="button" class="sm-size-popup__close" data-size-close>&times;</button>' +
'<div class="sm-size-popup__product">' +
'<img class="sm-size-popup__img" data-size-img src="" alt="">' +
'<div>' +
'<div class="sm-size-popup__title" data-size-title></div>' +
'<div class="sm-size-popup__price" data-size-price></div>' +
'</div>' +
'</div>' +
'<div class="sm-size-popup__label">Select Size</div>' +
'<div class="sm-size-popup__options" data-size-options></div>' +
'<button type="button" class="sm-btn sm-btn--primary sm-btn--full sm-size-popup__proceed" data-size-proceed disabled>' +
'<i class="fas fa-shopping-bag"></i> Proceed' +
'</button>' +
'</div>';
popup.style.display = 'none';
document.body.appendChild(popup);
var currentAction = 'add';
var currentForm = null;
var currentVariantInput = null;
var selectedVariantId = null;
var productUrl = '';
function openPopup(btn) {
var title = btn.dataset.productTitle || '';
var image = btn.dataset.productImage || '';
var price = btn.dataset.productPrice || '';
var variants = [];
try { variants = JSON.parse(btn.dataset.variants || '[]'); } catch(e) {}
currentAction = btn.dataset.action || 'add';
productUrl = btn.dataset.productUrl || '';
currentForm = btn.closest('[data-product-form]') || btn.closest('form');
currentVariantInput = currentForm ? currentForm.querySelector('[data-card-variant-input]') : null;
selectedVariantId = null;
popup.querySelector('[data-size-title]').textContent = title;
popup.querySelector('[data-size-price]').textContent = price;
var img = popup.querySelector('[data-size-img]');
if (image) { img.src = image; img.style.display = 'block'; }
else { img.style.display = 'none'; }
var optionsEl = popup.querySelector('[data-size-options]');
optionsEl.innerHTML = '';
variants.forEach(function(v) {
var btn = document.createElement('button');
btn.type = 'button';
btn.className = 'sm-size-popup__size' + (v.available ? '' : ' is-soldout');
btn.textContent = v.title;
btn.disabled = !v.available;
btn.dataset.variantId = v.id;
if (v.available) {
btn.addEventListener('click', function(e) {
e.stopPropagation();
optionsEl.querySelectorAll('.sm-size-popup__size').forEach(function(s) { s.classList.remove('is-selected'); });
this.classList.add('is-selected');
selectedVariantId = v.id;
// Auto-proceed immediately on size tap
var proceedBtn = popup.querySelector('[data-size-proceed]');
proceedBtn.disabled = true;
if (currentAction === 'buy') {
proceedBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Please wait...';
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
credentials: 'same-origin',
body: JSON.stringify({ items: [{ id: parseInt(v.id), quantity: 1 }] })
})
.then(function() {
closePopup();
goToCheckout();
})
.catch(function() { goToCheckout(); });
} else {
proceedBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Adding...';
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
credentials: 'same-origin',
body: JSON.stringify({ items: [{ id: parseInt(v.id), quantity: 1 }] })
})
.then(function(r) { return r.json().then(function(data) { return { ok: r.ok, data: data }; }); })
.then(function(res) {
closePopup();
if (!res.ok) { toast((res.data && res.data.description) || 'Could not add to bag'); return; }
var SM2 = window.ShoppingMood;
SM2.getCart().then(function(cart) {
SM2.renderCart(cart);
SM2.updateCartCount(cart.item_count);
SM2.openCart();
SM2.toast((SM.strings && SM.strings.addedToCart) || 'Added to bag!');
});
})
.catch(function() { closePopup(); toast('Something went wrong. Please try again.'); });
}
});
}
optionsEl.appendChild(btn);
});
var proceedBtn = popup.querySelector('[data-size-proceed]');
proceedBtn.disabled = true;
if (currentAction === 'buy') {
proceedBtn.innerHTML = '<i class="fas fa-bolt"></i> Buy Now';
} else {
proceedBtn.innerHTML = '<i class="fas fa-shopping-bag"></i> Add to Bag';
}
popup.style.display = 'flex';
}
function closePopup() {
popup.style.display = 'none';
}
popup.querySelector('[data-size-proceed]').addEventListener('click', function() {
if (!selectedVariantId) return;
var proceedBtn = this;
proceedBtn.disabled = true;
if (currentAction === 'buy') {
proceedBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Please wait...';
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
credentials: 'same-origin',
body: JSON.stringify({ items: [{ id: parseInt(selectedVariantId), quantity: 1 }] })
})
.then(function(r) {
if (r.ok) {
window.location.replace('/checkout');
} else {
window.location.replace('/cart');
}
})
.catch(function() {
window.location.replace('/cart');
});
} else {
proceedBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Adding...';
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
credentials: 'same-origin',
body: JSON.stringify({ items: [{ id: parseInt(selectedVariantId), quantity: 1 }] })
})
.then(function(r) { return r.json().then(function(data) { return { ok: r.ok, data: data }; }); })
.then(function(res) {
closePopup();
if (!res.ok) {
toast((res.data && res.data.description) || 'Could not add to bag');
return;
}
var SM2 = window.ShoppingMood;
SM2.getCart().then(function(cart) {
SM2.renderCart(cart);
SM2.updateCartCount(cart.item_count);
SM2.openCart();
SM2.toast((SM.strings && SM.strings.addedToCart) || 'Added to bag!');
});
})
.catch(function() {
closePopup();
toast('Something went wrong. Please try again.');
});
}
});
popup.querySelectorAll('[data-size-close]').forEach(function(el) {
el.addEventListener('click', closePopup);
});
document.addEventListener('click', function(e) {
var trigger = e.target.closest('[data-open-size-popup]');
if (trigger) {
e.preventDefault();
e.stopPropagation();
openPopup(trigger);
}
});
})();
})();
(function() {
function applyResponsiveBg() {
var isMobile = window.innerWidth < 768;
document.querySelectorAll('[data-desktop-bg]').forEach(function(el) {
var url = isMobile ? el.dataset.mobileBg : el.dataset.desktopBg;
if (url) el.style.backgroundImage = "url('" + url + "')";
});
}
applyResponsiveBg();
window.addEventListener('resize', applyResponsiveBg);
})();
